import {FC} from "react";
import {useTranslation} from "next-i18next";
import {motion} from 'framer-motion';
import {i18translateType, TitleGreenSpanSecondType,} from "../../@types/types-body";

export const TitleGreenSpanFirst: FC<TitleGreenSpanSecondType> = ({
                                                                      namespace, id, title, span, description,
                                                                  }) => {
    const {t}: i18translateType = useTranslation(namespace);
    return (<div className="section-title relative z-20 text-center mb-7.5 lg:mb-15 overflow-hidden">
        <motion.div
            key={id}
            animate={{x: [-400, 400, 0]}}
            transition={{delay: 2, duration: 3, ease: "easeInOut"}}
            className=""
        >
            <h2 className="overflow-hidden title m-0 child:text-crowlyn child:font-normal text-secondary text-xl md:text-4xl lg:text-5xl leading-heading lg:leading-heading">
                <span> {t(`${span}`)} </span> {t(`${title}`)}
            </h2>
            <p>{t(`${description}`)}</p>
        </motion.div>
    </div>);
};
